import React, { useState, useEffect } from 'react';

const TaskModal = ({ task, columns, onSubmit, onClose, isEditing }) => {
  const [currentTask, setCurrentTask] = useState(task);

  useEffect(() => {
    setCurrentTask(task);
  }, [task]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(currentTask);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>{isEditing ? 'Editar Tarea' : 'Agregar Tarea'}</h2>
        {columns.length === 0 ? (
          <p>No hay columnas disponibles. Crea una columna primero.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Título"
              value={currentTask.title}
              onChange={(e) => setCurrentTask({ ...currentTask, title: e.target.value })}
              required
            />
            <textarea
              placeholder="Descripción"
              value={currentTask.description}
              onChange={(e) => setCurrentTask({ ...currentTask, description: e.target.value })}
              required
            />
            <select
              value={currentTask.columnId}
              onChange={(e) => setCurrentTask({ ...currentTask, columnId: e.target.value })}
            >
              <option value="" disabled>Selecciona la categoría</option>
              {columns.map(column => (
                <option key={column.id} value={column.id}>{column.name}</option>
              ))}
            </select>
            <button type="submit">{isEditing ? 'Actualizar' : 'Agregar'}</button>
          </form>
        )}
        <button type="button" onClick={onClose}>Cancelar</button>
      </div>
    </div>
  );
};

export default TaskModal;

